export const comments_5256809 = {"data":{"data":[],"links":{}}}